export default "__VITE_ASSET__BcY$DByi__"